export const GET_INTERACTIONS = 'GET_INTERACTIONS';
export const GET_INTERACTION_BY_ID = 'GET_INTERACTION_BY_ID';
export const UPDATE_INTERACTION = 'UPDATE_INTERACTION';
export const DELETE_INTERACTION = 'DELETE_INTERACTION';
export const CREATE_INTERACTION = 'CREATE_INTERACTION';
